import { render, staticRenderFns } from "./NotificationSettingsBlock.vue?vue&type=template&id=6c2745d6&scoped=true&functional=true"
import script from "./NotificationSettingsBlock.vue?vue&type=script&lang=ts"
export * from "./NotificationSettingsBlock.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "6c2745d6",
  null
  
)

export default component.exports